<template>
    <form @submit.prevent="updateUser">
            <div v-if="!isLoaded">
        <div>
            <div class="row">
                <div class="col-lg-12">
                    Cargando...
                </div>
            </div>
        </div>
    </div>
        <div v-if="isLoaded">
            <!-- Select de Clientes -->
            <div class="row">
                <div class="col-md-6">
                    <input type="hidden" id="user-id" v-model="selectedUser.user_id">
                    <label for="name" class="form-label">Nombre</label>
                    <input type="text" id="name" class="form-control" v-model="selectedUser.name" required>
                </div>
                <div class="col-md-6">
                    <label for="last-name" class="form-label">Apellido</label>
                    <input type="text" id="last-name" class="form-control" v-model="selectedUser.last_name" required>
                </div>
            </div>
            <div class="mb-3 row">
                <div class="col-md-12">
                    <label for="email" class="form-label">Correo</label>
                    <input type="text" id="email" class="form-control" v-model="selectedUser.email" disabled>
                </div>
                <div class="col-md-12">
                    <label for="personal-email" class="form-label">Correo Personal</label>
                    <input type="email" id="personal-email" class="form-control" v-model="selectedUser.personal_email">
                </div>
            </div>
            <div class="mb-3 row">
                <div class="col-md-6">
                    <label for="new-pass" class="form-label">Nueva Contraseña:</label>
                    <input type="password" id="new-pass" class="form-control" placeholder="Nueva Contaseña">
                </div>
                <div class="col-md-6">
                    <label for="confirm-new-pass" class="form-label">Confirma Contraseña:</label>
                    <input type="password" id="confirm-new-pass" class="form-control" placeholder="Confirma Contaseña">
                </div>
            </div>
            <div class="mb-3 row">
                <div class="col-md-4">
                    <label for="teams" class="form-label">Equipo:</label>
                    <select id="teams" v-model="selectedTeam" class="form-control" required>
                        <option v-if="selectedUser?.team_id" :value="selectedUser.team_id" selected>
                            {{ selectedUser.team }}
                        </option>
                        <option v-for="team in teams" :key="team.team_id" :value="team.team_id">
                            {{ team.team }}
                        </option>
                    </select>
                </div>
                <div class="col-md-4">
                    <label for="user-type" class="form-label">Tipo de Usuario:</label>
                    <select id="user-type" v-model="selectedUserType" class="form-control" required>
                        <option v-if="selectedUser?.user_type_id" :value="selectedUser.user_type_id" selected>
                            {{ selectedUser.user_type }}
                        </option>
                        <option v-for="userType in userTypes" :key="userType.user_type_id"
                            :value="userType.user_type_id">
                            {{ userType.user_type }}
                        </option>
                    </select>
                </div>
                <div class="col-md-2">
                    <label for="role" class="form-label">Autorizador?</label>
                    <div class="form-check form-switch mt-2 mb-0 ms-2">
                        <input v-model="selectedAuthType" class="form-check-input form-check-input-warning"
                            type="checkbox" />
                    </div>
                </div>
                <div class="col-md-2">
                    <label for="role" class="form-label">PM?</label>
                    <div class="form-check form-switch mt-2 mb-0 ms-2">
                        <input v-model="selectedPMType" class="form-check-input form-check-input-warning"
                            type="checkbox" />
                    </div>
                </div>
            </div>
            <div class="mb-4 row">
                <div class="col-md-8">
                    <label for="role" class="form-label">Puesto:</label>
                    <input type="text" id="role" class="form-control" v-model="selectedUser.role">
                </div>
                <div class="col-md-4">
                    <label for="role" class="form-label">Factorial ID:</label>
                    <input type="text" id="factorial-id" class="form-control" v-model="selectedUser.factorial_id">
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <button type="submit" class="btn btn-warning w-100">Guardar</button>
                </div>
            </div>
        </div>
    </form>
</template>

<script setup>

import { onMounted, ref, defineProps } from 'vue';

import axios from 'axios';
const token = localStorage.getItem('authToken');
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const teams = ref([]);
const userTypes = ref([]);
const isLoaded = ref(false)

const selectedUser = ref({}); // Usuario seleccionado para editar
const selectedTeam = ref(""); // Definir el valor inicial como una cadena vacía.
const selectedUserType = ref("");
const selectedAuthType = ref("")
const selectedPMType = ref("")

const props = defineProps({
    selectedData: Object,
});

const fetchEditUserInfo = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/update-user-info`, { user_id: props.selectedData.user_id }, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        selectedUser.value = response.data[0]; // Guardar los datos en selectedUser
        selectedTeam.value = selectedUser.value.team_id
        selectedUserType.value = selectedUser.value.user_type_id
        selectedAuthType.value = selectedUser.value.can_auth
        selectedPMType.value = selectedUser.value.is_pm

        isLoaded.value = true

    } catch (error) {
        console.error('Error al obtener la información del usuario:', error);
    }
}


// Función para obtener los datos de los equipos
const fetchTeamsData = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/teams`, {}, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        teams.value = response.data; // Guardar los datos en teams
    } catch (error) {
        console.error('Error al obtener la información del usuario:', error);
    }
}

// Función para obtener los datos de los tipos de usuario
const fetchUserTypesData = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/user-types`, {}, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        userTypes.value = response.data; // Guardar los datos en userTypes
    } catch (error) {
        console.error('Error al obtener la información del usuario:', error);
    }
}

const updateUser = async () => {

    // Obtener valores de los campos de contraseña
    const newPassword = document.getElementById("new-pass")?.value || "";
    const confirmNewPassword = document.getElementById("confirm-new-pass")?.value || "";

    // Validar si se ingresó una nueva contraseña
    if ((newPassword || confirmNewPassword) && newPassword !== confirmNewPassword) {
        alert("Las contraseñas no coinciden");
        return;
    }

    // Construcción del objeto con los datos
    const updatedUserData = {
        user_id: selectedUser.value?.user_id || null,
        name: selectedUser.value?.name || "",
        last_name: selectedUser.value?.last_name || "",
        personal_email: selectedUser.value?.personal_email || "",
        team_id: selectedTeam.value || null,
        user_type_id: selectedUserType.value || null,
        role_title: selectedUser.value?.role || "",
        can_auth: selectedAuthType.value,
        is_pm: selectedPMType.value,
        factorial_id: selectedUser.value?.factorial_id || "",
    };

    // **Solo agregar la contraseña si se ingresó**
    if (newPassword && confirmNewPassword) {
        updatedUserData.password = newPassword;
    }

    try {
        // Enviamos los datos al backend
        const response = await axios.post(`${API_BASE_URL}/update-user`, updatedUserData, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token si es necesario
            },
        });

        if (response.status === 200) {
            alert("Usuario Actualizado");
            window.location.reload();
            // Puedes refrescar los datos o cerrar el modal/formulario si es necesario
        }
    } catch (error) {
        console.error("Error al actualizar el usuario:", error);
        alert("Hubo un error al actualizar el usuario");
    }
}


onMounted(async () => {
    fetchEditUserInfo();
    fetchTeamsData();
    fetchUserTypesData();
})
</script>